import { apiErrorDataSlice } from "./reducer";

export const { setApiResult, setApiResults, resetApiResult } = apiErrorDataSlice.actions;
